<template>
    <!-- 系统特色 -->
    <div class="system_features">
        <div class="containers">
            <h1 class="partH1" ref="HeaderTitle">系统特色</h1>
            <ul class="system_features_ul" ref="ul">
                <li class="system_features_li" v-for="(item,index) in systemFeatures.part1" :key="index"  >
                    <div class="features_index">{{item.index}}</div>
                    <p>{{item.info}}</p>
                    <img :src="item.img">
                </li>
            </ul>
            <ul class="system_features_ul system_features_ul_last" ref="ul2">
                <li class="system_features_li" v-for="(item,index) in systemFeatures.part2" :key="index"  >
                    <div class="features_index">{{item.index}}</div>
                    <p>{{item.info}}</p>
                    <img :src="item.img">
                </li>

            </ul>
        </div>
    </div>

</template>

<script>
    import animationUtils from "@/utils/animationUtils.js";
    import animationIndex from "@/utils/animationIndex.js";

    export default {
        props: {
            systemFeatures: {
                type: Object,
                default: {}
            }
        },
       data() {
            return {
                // liDom: [],
            }
        },
        mounted() {
            // this.systemFeatures.forEach((item, index) => { //获取需要给加动画的各个li的ref节点
            //     this.liDom.push(this.$refs[`li${index}`][0].classList);
            // })
            window.addEventListener("scroll", this.menu);
        },
        beforeDestroy() { //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
            window.removeEventListener("scroll", this.menu)
        },
        methods: {
            menu() {
                let ulOffsetTop = this.$refs.ul.offsetTop; //获取当前元素距离文档顶部的高度
                let ulList = this.$refs.ul.classList; //获取当前元素距离文档顶部的高度
                let ul2OffsetTop = this.$refs.ul2.offsetTop; //获取当前元素距离文档顶部的高度
                let ul2List = this.$refs.ul2.classList; //获取当前元素距离文档顶部的高度
                /**
                 * animationIndex第一个参数为需要动画的dom元素的高度，
                 * 第二个参数为li的每个单元的dom样式类数组
                 * 第三个参数为动画样式类名称
                 * 第四个参数为每个li动画执行间隔时间
                 * */
                // animationIndex.animationIndex(ulOffsetTop, this.liDom, "fade--in", 600);

                /**
                 * animations方法的第一个参数是需要动画的dom元素的高度，
                 * 第二个参数是需要加动画的dom元素的样式列表数组，
                 * 第三参数是动画类型（样式类名）activeTitle：文字动画，activeShade图片出现前的遮罩动画，activeTitle图片动画
                 */
                //第二部分标题动画
                 let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop; //获取当前元素距离文档顶部的高度
                let HeaderTitle = this.$refs.HeaderTitle.classList;
                animationUtils.animations(ulOffsetTop, ulList, "activeTitle");
                animationUtils.animations(ul2OffsetTop, ul2List, "activeTitle");
                animationUtils.animations(HeaderTitleOffsetTop, HeaderTitle, "activeTitle");
            }
        },
    };
</script>

<style scoped>
    @media screen and (max-width: 1067px) {
        .system_features_li img {
            width: 260px;
            height: auto;
        }
    }

    @media screen and (min-width: 1067px) {
        .system_features_li img {
            width: 23.95833vw;
            height: auto;
        }
    }
</style>